export const inputs = [
  {
    advanced: false,
    type: 'input',
    id: 'series',
    label: 'Série RPS',
    placeholder: '0',
    value: ''
  },
  {
    advanced: false,
    type: 'input',
    id: 'number',
    label: 'N˚ RPS',
    placeholder: '0',
    value: ''
  },
  {
    advanced: false,
    type: 'input',
    id: 'nfNumber',
    label: 'N˚ NFS-e',
    placeholder: '0',
    value: ''
  },
  {
    advanced: false,
    type: 'select',
    id: 'typeDateTime',
    label: 'Filtrar por',
    placeholder: 'Filtrar por',
    value: 'paymentDateTime',
    options: [
      {
        label: 'Competência',
        value: 'paymentDateTime'
      },
      {
        label: 'Emissão',
        value: 'nfDateTime'
      }
    ]
  },
  {
    advanced: false,
    type: 'select',
    id: 'documentTypeId',
    label: 'Documento',
    placeholder: 'Documento',
    value: '0',
    options: [
      {
        label: 'Todos',
        value: '0'
      },
      {
        label: 'NFSe',
        value: '1'
      },
      {
        label: 'NFCe',
        value: '2'
      }
    ]
  }
];